import { normalizeLocale, type WidgetLocale } from './i18n'

/**
 * Behandlingers varighed i timer + minutter (OPG-0064): 90 → «1 t 30 min» (da) /
 * «1 h 30 min» (en); under en time «45 min», hele timer «2 t». Kopi af
 * apps/holdstyring/src/lib/treatments/duration.ts (pakken kan ikke importere fra
 * apps); duration-locale-parity.test.ts i HS holder de to ens.
 */
export const DURATION_UNITS: Record<WidgetLocale, { hours: string; minutes: string }> = {
  da: { hours: 't', minutes: 'min' },
  en: { hours: 'h', minutes: 'min' },
  de: { hours: 'Std.', minutes: 'Min.' },
  sv: { hours: 'tim', minutes: 'min' },
  nb: { hours: 't', minutes: 'min' },
  es: { hours: 'h', minutes: 'min' },
  fr: { hours: 'h', minutes: 'min' },
}

export function formatDuration(totalMinutes: number, locale?: string | null): string {
  const units = DURATION_UNITS[normalizeLocale(locale)]
  const total = Number.isFinite(totalMinutes) && totalMinutes > 0 ? Math.floor(totalMinutes) : 0
  const hours = Math.floor(total / 60)
  const minutes = total % 60
  if (hours === 0) return `${minutes} ${units.minutes}`
  if (minutes === 0) return `${hours} ${units.hours}`
  return `${hours} ${units.hours} ${minutes} ${units.minutes}`
}
